import { render, staticRenderFns } from "./EventType.vue?vue&type=template&id=3946136e"
import script from "./EventType.vue?vue&type=script&lang=ts"
export * from "./EventType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports